import React from 'react';
import * as msgpub from "msgpub";
import {TextArea} from '../Common';
import UserComponent from './UserComponent';
import TokenComponent from './TokenComponent';
import { DisabelesAdminContext } from '../../constant/AdminMqtt';


export default function UserTokenComponent(props: {admin?: msgpub.Admin}) {
    const {admin} = props;
    const [log, setLog] = React.useState('');
    const disables = React.useContext(DisabelesAdminContext);

    return (
        <div>
            <UserComponent admin={admin} setLog={setLog} />
            <TokenComponent admin={admin} setLog={setLog} />
            <TextArea texts={log} name={"log"} disabled={disables.others} id={"token-pub-sub-log"} onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                                                                                                {setLog(e.target.value)}}/>
        </div>
    );
}
